// src/shared/components/Layout.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import Navbar from 'shared/components/Navbar';
import ImintTopNav from 'features/imint/components/ImintTopNav';
import { useIsImintUser } from 'features/imint/access';

// Layout component that includes the header
const Layout = ({ children }) => {
  const location = useLocation();
  const auth = useAuth();
  // Auth screens (login, self-registration, email verification, OIDC callback)
  // are full-bleed and must NOT show the app navbar.
  const AUTH_ROUTES = ['/login', '/create-new-account', '/verify-email', '/auth/callback'];
  const isLoginPage = AUTH_ROUTES.includes(location.pathname);
  const landingpage = location.pathname === '/';
  // Users in the exclusive IMINT shell get the IMINT top bar instead of the
  // dashboard Navbar.
  const isImintUser = useIsImintUser();

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#0E0E0F' }}>
      {/* Conditionally render navbar — but NOT while the OIDC session is still
          restoring (reload): the role isn't knowable yet, and a blank strip
          beats flashing the wrong customer navbar at an IMINT user. */}
      {!isLoginPage && !landingpage && !auth.isLoading &&
        (isImintUser ? <ImintTopNav /> : <Navbar style={{ flexShrink: 0 }} />)}
      {/* Main content that takes up all remaining space */}
      <main style={{ flex: 1, overflow: 'hidden' }}>
        {children}
      </main>
    </div>
  );
};

export default Layout;
